import { render, staticRenderFns } from "./SubmodalProgressType.vue?vue&type=template&id=b2f313c2&"
import script from "./SubmodalProgressType.vue?vue&type=script&lang=js&"
export * from "./SubmodalProgressType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports